<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Approve page' | locale }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="success" (click)="approved()" [disabled]="inAction()"
        >Approve</ion-button
      >
      <ion-button color="danger" (click)="reject()" [disabled]="inAction()"
        >Reject</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<app-entity-read [entityId]="entityId()" [hideNavbar]="true" class="grow" />
